(() => {
  const grid = document.querySelector('[data-wishlist-grid]');
  const emptyState = document.querySelector('[data-wishlist-empty]');
  if (!grid || !window.WishlistProvider) return;

  function render() {
    const items = window.WishlistProvider.getAll();
    emptyState.hidden = items.length > 0;

    grid.innerHTML = items
      .map(
        (item) => `
        <div class="wishlist-page__card">
          <a href="${item.url}">
            ${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : ''}
          </a>
          <div class="wishlist-page__card-info">
            <a href="${item.url}" class="wishlist-page__card-title">${item.title}</a>
            <span class="wishlist-page__card-price">${item.price}</span>
            <button type="button" class="wishlist-page__card-remove" data-remove-handle="${item.handle}">
              ${window.WISHLIST_STRINGS?.remove || 'Remove'}
            </button>
          </div>
        </div>`
      )
      .join('');
  }

  grid.addEventListener('click', (event) => {
    const button = event.target.closest('[data-remove-handle]');
    if (!button) return;
    window.WishlistProvider.remove(button.dataset.removeHandle);
  });

  document.addEventListener('wishlist:change', render);
  render();
})();
